var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPinterestWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 0C63.6437 0 82 18.3563 82 41C82 63.6437 63.6437 82 41 82C18.3563 82 0 63.6437 0 41C0 18.3563 18.3563 0 41 0ZM42.2041 17.1162C28.1848 17.1162 21.1153 27.1381 21.1152 35.4961C21.1152 40.5568 23.0355 45.0591 27.1582 46.7373C27.8335 47.0122 28.4394 46.7451 28.6357 46C28.7704 45.4834 29.0948 44.181 29.2363 43.6396C29.4339 42.9013 29.3584 42.6419 28.8125 41.999C27.6254 40.5992 26.8672 38.7918 26.8672 36.2285C26.8672 28.794 32.4432 22.1379 41.3936 22.1377C49.3158 22.1377 53.6728 26.9646 53.6729 33.4131C53.6729 41.8962 49.9068 49.0564 44.3164 49.0566C41.2286 49.0566 38.9199 46.5107 39.6592 43.3896C40.5442 39.6625 42.2646 35.6385 42.2646 32.9482C42.2646 30.5411 40.9682 28.5312 38.2842 28.5312C35.1279 28.5313 32.5938 31.7873 32.5938 36.1475C32.5938 38.924 33.5361 40.8027 33.5361 40.8027C33.5312 40.8235 30.3062 54.448 29.7393 56.835C29.2109 59.0704 29.1426 61.5373 29.2256 63.5918L32.709 64.8594C33.8286 63.0922 35.0531 60.825 35.6787 58.5566C36.0405 57.2514 37.7419 50.5164 37.7539 50.4688C38.7804 52.4191 41.7774 54.1357 44.9629 54.1357C54.4488 54.1357 60.8838 45.5128 60.8838 33.9707C60.8837 25.245 53.4694 17.1164 42.2041 17.1162Z",
    fill: "#DAD7DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPinterestWhite);
export default __webpack_public_path__ + "static/media/logoPinterestWhite.cd6a82e033c4ec5d3ac9ecbe31cae6ae.svg";
export { ForwardRef as ReactComponent };